import React from 'react'
import { connect } from 'react-redux'
import find from 'lodash/find'

import {
  selectPaymentOption
} from './paymentMethodActionCreators'

import {
  OptionListItemRadio,
  CheckoutSection,
  hiddenAnchorStyle
} from '../../components'

import { Fade } from '../../componentAnimations'
import { TranslationUtility } from "../../../util/translationUtility";

const getById = (methods, id) => {
  return methods.filter(pm => pm.Id === id)[0];
}

class CheckoutPayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isCollapsed: false }
    this.onItemSelected = this.onItemSelected.bind(this)
    this.onClickChange = this.onClickChange.bind(this)
    this.onPaymentIsValid = this.onPaymentIsValid.bind(this)
    this.translationUtility = new TranslationUtility(props.localizationItems);
  }

  onPaymentIsValid() {
    this.setState({ isCollapsed: true });
  }

  onItemSelected(id) {
    const paymentOption = getById(this.props.paymentOptions, id);
    if (!paymentOption) {
      console.error(`No payment method with id '${id}'`);
      return;
    }
    if (!paymentOption.paymentOptionComponent) {
      this.setState({ isCollapsed: true });
    }
    this.props.onSelected(id, paymentOption.Name);
  }

  onClickChange(e) {
    e.preventDefault();
    this.setState({ isCollapsed: !this.state.isCollapsed });
  }

  render() {
    const items = this.props.paymentOptions.map(pm => {
      let selected = pm.Id === this.props.selectedPaymentOptionId;
      if (pm.paymentOptionComponent) {
        const PaymentOptionComponent = pm.paymentOptionComponent;

        return (
            <OptionListItemRadio
              key={pm.Id}
              id={pm.Id}
              isSelected={selected}
              onClick={this.onItemSelected}
              label={pm.Name}>
              <div className='col-12'>
                <PaymentOptionComponent
                  isSelected={selected}
                  onPaymentIsValid={this.onPaymentIsValid}
                  onPaymentCancel={this.props.onCancel}
                />
              </div>
            </OptionListItemRadio>
          )
      } else {
        return (<OptionListItemRadio
                   key={pm.Id}
                   id={pm.Id}
                   isSelected={selected}
                   onClick={this.onItemSelected}
                   label={pm.Name} />)
      }
    });
    const canChange = true;
    return (
      <CheckoutSection label={this.translationUtility.translateResourceString("/Checkout/Payment/Label")} hidden={false}>
        <div style={{ lineHeight: 2 }}>
          <a
            href=""
            style={hiddenAnchorStyle}
            onClick={(e) => this.onClickChange(e)}
          >
            {this.props.selectedDisplay || <em>Select Payment Method</em>}
            {canChange &&
              <span style={{ marginLeft: 20, color: '#3cb7e3' }}>
                {this.state.isCollapsed ? 'Change' : 'Done'}
              </span>}
          </a>
        </div>
        <Fade inProp={!this.state.isCollapsed}>
          <div style={{ display: this.state.isCollapsed ? 'none' : 'inherit' }}>
            {items}
          </div>
        </Fade>
      </CheckoutSection>
    );
  }
}

const formatPayment = ({constants, entities}) => {
  
  const formatPaypalPayloadDetailsForSummary = (det) => {
    if (det) {
      if (typeof (det.firstName) !== 'undefined' && typeof (det.lastName) !== 'undefined' && typeof(det.email) !== 'undefined') {
        return `${det.firstName.length > 0 ? det.firstName + " " : ""}${det.lastName.length > 0 ? det.lastName + " " : ""} (${det.email})`;
      } else if (typeof (det.email) !== 'undefined' && det.email.length > 0) {
        return det.email;
      }
    }
    return "unspecified";
  }

  let formatters = [
    //{
    //  Id: constants.purchaseOrderPaymentId,
    //  format: ({ POValue }) =>
    //    (`Purchase Order ${((POValue && POValue.length > 0) ? " #: " : "")}${POValue || ""}`)
    //},
    {
      Id: constants.braintreeSettings.braintreePaymentId,
      format: ({ BraintreePaymentPayload }) => {
        if (!BraintreePaymentPayload) {
          return "Pending";
        } else {
          if (BraintreePaymentPayload.type === "PayPalAccount") {
            return `Paypal: ${formatPaypalPayloadDetailsForSummary(BraintreePaymentPayload.details)}`;
          } else if (BraintreePaymentPayload.type === "CreditCard") {
            return `Card: ${BraintreePaymentPayload.description}`
          } else {
            return "Unknown payment method";
          }

        }
      }
    }
  ];
  const formatter = find(formatters, x => x.Id === entities.SelectedPaymentOptionId);
    if (formatter) {
        return formatter.format(entities.PaymentRecord);
    } else {
        const selectedOption = find(entities.PaymentOptions, po => po.Id === entities.SelectedPaymentOptionId);
        return selectedOption && selectedOption.Name;
    }
}

const mapCheckoutPaymentStateToProps = (state) => {
  return {
    paymentOptions: state.entities.PaymentOptions,
    selectedPaymentOptionId: state.entities.SelectedPaymentOptionId,
    selectedDisplay: formatPayment(state),
    localizationItems: state.constants.localizationItems
  }
}

const mapCheckoutPaymentDispatchToProps = (dispatch) => {
  return {
    onSelected: (id, displayName) => dispatch(selectPaymentOption(id, displayName)),
    onCancel: () => dispatch(selectPaymentOption(''))
  }
}

const CheckoutPaymentContainer = connect(
  mapCheckoutPaymentStateToProps,
  mapCheckoutPaymentDispatchToProps
)(CheckoutPayment);


export default CheckoutPaymentContainer


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/PaymentMethod/CheckoutPayment.jsx